import script from "./DialogBlowdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogBlowdown.vue?vue&type=script&setup=true&lang=ts"

import "./DialogBlowdown.vue?vue&type=style&index=0&id=31da644a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31da644a"]])

export default __exports__